import React from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import './translations/i18n';

import './styles/index.scss';

const container = document.getElementById('root');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);

// See `./docker/config/README.md`
root.render(<App env={window.ENV} />);
